import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const ironclad = defineConnector({
  identifier: "ironclad",
  name: "Ironclad",
  tagLine: "Digital contracting platform",
  logo,
  protocol: "http",
  tags: ["productivity", "documents"],
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Create an Ironclad OAuth access token",
      items: [
        {
          kind: "markdown",
          content:
            "In Ironclad, register an OAuth client, request an OAuth 2.0 access token, and use that token as a bearer token for API requests.",
        },
      ],
    },
    {
      title: "Enter your Ironclad details",
      items: [
        {
          kind: "baseUrl",
          label: "Ironclad base URL",
          required: true,
          placeholder: "https://na1.ironcladapp.com",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "OAuth access token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl || "https://na1.ironcladapp.com"}/public/api/v1/workflows`,
  },
  defaultUrlPattern: ({ instanceUrl }) =>
    urlToPattern(instanceUrl, "https://[^/]*\\.ironcladapp\\.com/.*"),
});
